const setStateMutation = (state, payload) => {
    Object.assign(state, payload);
}

const resetFilterMutation = (state, payload) => {
    state[payload].filters.options.forEach(option => {
        option.selected = false;
    });
}

const removeFilterMutation = (state, payload) => {
    Object.assign(payload, {selected: false})
}

const resetAllFiltersMutation = (state, payload) => {
    state[payload].filters.options.forEach(option => {
        option.selected = false;
    });
}

const setPageMutation = (state, payload) => {
    state[payload.id].page = payload.page
}

const setItemsMutation = (state, payload) => {
    Object.assign(state.upcoming, {events: payload.upcoming})
    Object.assign(state.past, {events: payload.past})
}

const setTotalMutation = (state, payload) => {
    state.upcoming.total = payload.upcoming;
    state.past.total = payload.past;
}

const setLoadingMutation = (state, payload) => {
    state[payload.id].loading = payload.loading;
}

const setCanLoadMoreMutation = (state, payload) => {
    state.upcoming.canLoadMore = payload.upcoming
    state.past.canLoadMore = payload.past
}

const mutations = {
    setState: setStateMutation,
    resetFilter: resetFilterMutation,
    removeFilter: removeFilterMutation,
    resetAllFilters: resetAllFiltersMutation,
    setPage: setPageMutation,
    setItems: setItemsMutation,
    setTotal: setTotalMutation,
    setLoading: setLoadingMutation,
    setCanLoadMore: setCanLoadMoreMutation
}

export default mutations;